import { IComponentOptions } from "angular";
import { MachineDetailProgressiveConfigurationComponentController } from "./controller";

export const vsComponentName = "machineDetailProgressiveConfigurationComponent";

export const MachineDetailProgressiveConfigurationComponentOptions: IComponentOptions =
  {
    controller: MachineDetailProgressiveConfigurationComponentController,
    controllerAs: "componentController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machine: "<",
      progressiveInformation: "<",
    },
  };
